/**
 * @Create idler.zhu(zqc.sunny@aliyun.com)
 * @CreateDate  2017/12/6
 */
import React, {Component} from 'react';

class NotFound extends Component {
  render (){
    return <div>404</div>
  }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/components/notFound/index.js